import { EventEmitter } from "pixi.js";


export enum EnumEventBus {
  moveAllPoints = "MOVE_ALL_POINTS",
  moveCircumPoints = "MOVE_CIRCUMFERENCE_POINTS",
  setPointChecklist = "SET_POINT_CHECK_LIST",
  setRefPoints = "SET_REF_POINTS",
  catMode = "CAT_MODE",
  showSecondAngles = "SHOW_SECOND_ANGLES",
  segmentMode = "SEGMENT_MODE"
}

export const eventBus = new EventEmitter();